import React, { useState } from "react";
import { FaRegHeart } from "react-icons/fa";
import AppUnlockModal from "./AppUnlockModal";

/**
 * Heart control that opens the “unlock app” modal (favorites live in native app).
 */
export default function FavoriteAppUnlockButton({
  className = "",
  variant = "default",
  ariaLabel = "Add to favorites",
}) {
  const [open, setOpen] = useState(false);
  const hero = variant === "hero";
  const row = variant === "row";

  return (
    <>
      <button
        type="button"
        className={[
          "favorite-app-unlock-btn",
          hero ? "favorite-app-unlock-btn--hero" : "",
          row ? "favorite-app-unlock-btn--md" : "",
          className,
        ]
          .filter(Boolean)
          .join(" ")}
        onClick={() => setOpen(true)}
        aria-label={ariaLabel}
      >
        <FaRegHeart aria-hidden />
      </button>
      <AppUnlockModal
        open={open}
        onClose={() => setOpen(false)}
        title="Unlock all features"
        message="Install the app to save favorites and access full experience."
        bannerMessage
      />
    </>
  );
}
